import React from 'react';

import styled from '@emotion/styled';

import { PrimaryButton } from '../Button';

interface ICard {
  age: string;
  experience: string;
  location: string;
  availability: string;
}

const HeaderModalProfileCard: React.FC<ICard> = ({
  age,
  experience,
  location,
  availability,
}) => {
  return (
    <Container>
      <Paragraph>Basic Information</Paragraph>
      <Details>
        <Age>
          <Label>Age:</Label>
          <P> {age} </P>
        </Age>
        <Experience>
          <Label>Years of Experience</Label>
          <P> {experience} </P>
        </Experience>
        <Location>
          <Label>Location</Label>
          <P> {location} </P>
        </Location>
        <Availability>
          <Label>Availability</Label>
          <P> {availability} </P>
        </Availability>
      </Details>
      <Button>
        <PrimaryButton className="bigg">Schedule an interview</PrimaryButton>
        <PrimaryButton className="bigg1">View CV</PrimaryButton>
      </Button>
    </Container>
  );
};

export default HeaderModalProfileCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  // position: absolute;
  background-color: white;
  width: 100%;
  color: black;
  box-shadow: 0px 20px 26px 0px rgba(186, 182, 182, 0.16);
  border-radius: 0.25rem;
  padding: 2rem 1rem 0.5rem 3rem;
`;

const Details = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
`;

const Paragraph = styled.div`
  jsutify-content: center;
  align-items: center;
  height: 3.125rem;
  font-weight: 600;
  font-size: 1.5rem;
  //   margin-top: -1rem;
`;

const Label = styled.div`
  font-size: 1rem;
  color: #828282;
`;

const P = styled.p`
  font-weight: 400;
  font-size: 1rem;
  // border: 2px solid blue;
`;

const Age = styled.div`
  display: flex;
  flex-direction: column;
`;

const Experience = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: -7rem;
  color: ${({ theme }) => theme.palette.greyGrey1};
`;

const Location = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: -7rem;
`;

const Availability = styled.div`
  display: flex;
  flex-direction: column;
`;

const Button = styled.div`
  display: flex;
  gap: 1rem;
  position: relative;
  bottom: 2.5rem;
  left: 12rem;
`;
